import { gql } from "@apollo/client";

export default gql`
  mutation createFaq($data: CreateFAQInput!) {
    createFaq(data: $data) {
      id
    }
  }
`;
